import React from 'react';

import { ColorSwatch, Flex, Grid, Text } from '@mantine/core';
import { IconPalette } from '@tabler/icons-react';
import { GradientSwatch } from 'components/GradientSwatch';
import { OverviewCard } from 'pages/GuestSmartAssistant/GuestDashboard/OverviewTab/OverviewCard';
import { useTranslation } from 'react-i18next';
import { SmartAssistant } from 'shared/interfaces/SmartAssistant';

interface ThemeOverviewProps {
  smartAssistant: SmartAssistant;
}

export function ThemeOverview({ smartAssistant }: ThemeOverviewProps) {
  const { t } = useTranslation();

  const colors = [
    {
      color: smartAssistant.assistantMessageColor,
      label: t('SMART_ASSISTANT.OVERVIEW_SECTION.THEME.ASSISTANT_MESSAGE_COLOR'),
      colorType: 'unique'
    },
    {
      color: smartAssistant.userMessageColor,
      label: t('SMART_ASSISTANT.OVERVIEW_SECTION.THEME.USER_MESSAGE_COLOR'),
      colorType: 'unique'
    },
    {
      color: smartAssistant.conversationBackgroundColor,
      label: t('SMART_ASSISTANT.OVERVIEW_SECTION.THEME.CONVERSATION_BACKGROUND_COLOR'),
      colorType: 'unique'
    },
    {
      color: smartAssistant.secondaryBackgroundColor,
      label: t('SMART_ASSISTANT.OVERVIEW_SECTION.THEME.SECONDARY_BACKGROUND_COLOR'),
      colorType: 'unique'
    },
    {
      colors: smartAssistant.gradientColors,
      label: t('SMART_ASSISTANT.OVERVIEW_SECTION.THEME.GRADIENT_COLOR'),
      colorType: 'gradient'
    }
  ];

  return (
    <OverviewCard title={t('SMART_ASSISTANT.OVERVIEW_SECTION.THEME.TITLE')} icon={<IconPalette />}>
      <Grid gutter="xs">
        {/* First row */}
        <Grid.Col span={6}>
          <Flex direction="row" align="center" gap="md">
            <ColorSwatch color={colors[0].color || ''} />
            <Text size="sm">{colors[0].label}</Text>
          </Flex>
        </Grid.Col>
        <Grid.Col span={6}>
          <Flex direction="row" align="center" gap="md">
            <ColorSwatch color={colors[1].color || ''} />
            <Text size="sm">{colors[1].label}</Text>
          </Flex>
        </Grid.Col>
        {/* Second row */}
        <Grid.Col span={6}>
          <Flex direction="row" align="center" gap="md">
            <ColorSwatch color={colors[2].color || ''} />
            <Text size="sm">{colors[2].label}</Text>
          </Flex>
        </Grid.Col>
        <Grid.Col span={6}>
          <Flex direction="row" align="center" gap="md">
            <ColorSwatch color={colors[3].color || ''} />
            <Text size="sm">{colors[3].label}</Text>
          </Flex>
        </Grid.Col>
        {/* Third row: Gradient aligned with first column */}
        <Grid.Col span={6}>
          <Flex direction="row" align="center" gap="md">
            <GradientSwatch colors={colors[4].colors || []} size={25} />
            <Text size="sm">{colors[4].label}</Text>
          </Flex>
        </Grid.Col>
        <Grid.Col span={6} /> {/* Empty column for alignment */}
      </Grid>
    </OverviewCard>
  );
}
